import { Typography } from "@mui/material";
import * as React from "react";
import { ITreeCheckBoxDropdownItem } from "../TreeCheckboxDropdownItems/TreeCheckboxDropdownItems";

interface ITreeCheckboxDropdownValueWithCommentProps {
    item: ITreeCheckBoxDropdownItem;
    onGetTitleSuffix?: (id: string) => React.ReactNode | string;
}

export const TreeCheckboxDropdownValueWithComment = (props: ITreeCheckboxDropdownValueWithCommentProps) => (
    <div>
        <Typography>{props.item.getTitle()}{props.onGetTitleSuffix?.(props.item.id) ?? null}</Typography>
        {props.item.comment &&
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", textWrap: "auto", wordBreak: "break-word", maxWidth: "500px" }}>{props.item.comment}</Typography>
        }
    </div>
);
